import { render, staticRenderFns } from "./modal-detail-product.vue?vue&type=template&id=70b63a96&"
import script from "./modal-detail-product.vue?vue&type=script&lang=js&"
export * from "./modal-detail-product.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports